import { parseFullName } from 'parse-full-name';

import type { ChangeRequest } from '@gitbook/api-client';
import type { ChangeRequest as DBChangeRequest } from '@gitbook/app-database';

import { getShortDate } from './date';

type AnyChangeRequest = ChangeRequest | DBChangeRequest;

/**
 * Returns a change request's subject or creates a default one.
 */
export function getChangeRequestSubject(changeRequest: AnyChangeRequest) {
    const { subject, createdBy, createdAt } = changeRequest;
    if (subject) {
        return subject;
    }

    if (!createdBy) {
        return '';
    }

    const displayName = typeof createdBy === 'string' ? createdBy : createdBy.displayName;

    const { first } = parseFullName(displayName);

    const name = first || displayName;

    const date = getShortDate(new Date(createdAt.toString()));

    return `${name}'s ${date} changes`;
}

/**
 * Returns a change request's title.
 * @example "#123 - My changes"
 */
export function getChangeRequestTitle(changeRequest: AnyChangeRequest): string {
    return `#${changeRequest.number} - ${getChangeRequestSubject(changeRequest)}`;
}
